module.exports = __webpack_public_path__ + "static/media/eco-ecology-leaf-4-svgrepo-com.ec23b70c.svg";